import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Box, LinearProgress } from '@mui/material'
import { BaseButtons, BaseGridLayout, ICONE } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { CHIAVI_SESSIONE } from 'configuration/ConfigurazioneSessione'
import { LINK_RITORNO_SPID } from 'configuration/link'
import ConfigManager from 'components/config/ConfigManager'
import Titoletto from 'components/ui/Titoletto'
import { useSessione } from 'context/SessioneProvider'
import useNavigate from 'utils/useNavigate'

const CFG = LINK_RITORNO_SPID

export default function RitornoSPID() {
  const { esito } = useParams()
  return esito === 'ok' ? <RitornoOk /> : <RitornoFail />
}



function RitornoOk() {
  const { navigate } = useNavigate()

  const {
    [CHIAVI_SESSIONE.CHIAVE_ROTTA_DOPO_ACCESSO]: chiaveRottaDopoAccesso
  } = useSessione()

  useEffect(() => {
    navigate(chiaveRottaDopoAccesso)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box sx={{ p: 4 }}>
      <LinearProgress />
    </Box>
  )
}



function RitornoFail() {
  const {
    [CHIAVI_SESSIONE.CHIAVE_ROTTA_HOME_SERVIZIO]: chiaveRottaHomeServizio
  } = useSessione()

  function tornaAllaHome() {
    window.location.href = chiaveRottaHomeServizio
  }

  return (
    <Box sx={{ p: 4 }}>
      <ConfigManager
        elenchiConfig={[ELENCHI.CFG_LINK_RITORNO_SPID]}
        render={({ val, txt }) =>
          <>
            <BaseGridLayout alignCenter spacing={1}>
              <ICONE.ERRORE />
              <Titoletto>{txt(CFG.ERRORE_ACCESSO_TITOLO)}</Titoletto>
            </BaseGridLayout>
            
            <BaseButtons.Logout
              testo={val(CFG.ERRORE_ACCESSO_TORNA_HOME)}
              color='primary'
              onClick={tornaAllaHome}
            />
          </>
        }
      />
    </Box>
  )
}